var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { IconButton, useToast, Loader, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useTasks } from 'app/domains/tasks/components/TasksProvider';
import { useDeleteTask } from '../../hooks/useDeleteTask';
export function TaskDropdown(props) {
    const { taskId, completed } = props;
    const { mutate, loading } = useDeleteTask();
    const { handleEditTask } = useTasks();
    const { addToast } = useToast();
    const handleEdit = () => {
        handleEditTask(taskId);
    };
    const handleDelete = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield mutate(taskId);
            addToast({
                title: t `Task deleted`,
                appearance: 'success',
            });
        }
        catch (deleteMutationError) {
            addToast({
                title: t `An error occurred`,
                appearance: 'danger',
            });
        }
    });
    return (<Menu.Root target={<IconButton disabled={loading} size="small" appearance="ghost" $round>
          {loading ? <Loader /> : <Falcon icon="ellipsis-v"/>}
        </IconButton>}>
      {!completed && (<Menu.Item onClick={handleEdit}>
          <Falcon icon="edit"/>
          <Trans>Edit</Trans>
        </Menu.Item>)}
      <Menu.Item data-testid="task-action-delete" onClick={handleDelete}>
        <Falcon icon="trash"/>
        <Trans>Delete task</Trans>
      </Menu.Item>
    </Menu.Root>);
}
